function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import styled from '../styled-components';
import AngleUp from '../icons/AngleUp';
import { createDropdown } from '@webnuts/shared-components';
var ItemList =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "Dropdown__ItemList",
  componentId: "n49ci5-0"
})(["position:absolute;background-color:", ";width:100%;z-index:", ";cursor:pointer;box-shadow:0 0 8px 0 rgba(0,0,0,0.05);max-height:300px;overflow-y:auto;border:1px solid ", ";border-top:none;border-bottom-left-radius:3px;border-bottom-right-radius:3px;"], function (props) {
  return props.theme.color.text.white;
}, function (props) {
  return props.theme.zIndex.dropdown;
}, function (props) {
  return props.theme.color.primary.lightBlue;
});

function DropdownButton(_ref) {
  var option = _ref.option,
      props = _objectWithoutProperties(_ref, ["option"]);

  var display = option ? option.render ? option.render(option.value) : option.label : 'Vælg';
  return React.createElement("button", props, React.createElement("span", null, display), " ", React.createElement(Caret, {
    width: 9
  }));
}

function DropdownItem(_ref2) {
  var option = _ref2.option,
      props = _objectWithoutProperties(_ref2, ["option"]);

  var display = option.render ? option.render(option.value) : option.label;
  return React.createElement("div", props, display);
}

var Caret =
/*#__PURE__*/
styled(AngleUp).withConfig({
  displayName: "Dropdown__Caret",
  componentId: "n49ci5-1"
})(["margin-left:16px;margin-right:4px;color:#303030;transform:rotate(180deg);"]);
var Button =
/*#__PURE__*/
styled(DropdownButton).withConfig({
  displayName: "Dropdown__Button",
  componentId: "n49ci5-2"
})(["outline:none;&::-moz-focus-inner{border:0;}border:0;-webkit-appearance:none;background-color:transparent;display:flex;align-items:center;justify-content:space-between;font-family:'Lato',sans-serif;font-size:14px;padding:0px 15px;height:45px;width:100%;cursor:pointer;>:first-child{flex:1 1 auto;text-align:left;}&:disabled{color:", ";border:0;cursor:default;background-color:#f4f4f4 !important;", "{opacity:0.25;}}"], function (props) {
  return props.theme.color.grey.dark;
}, Caret);
var Item =
/*#__PURE__*/
styled(DropdownItem).withConfig({
  displayName: "Dropdown__Item",
  componentId: "n49ci5-3"
})(["border-top:1px solid #ededed;display:flex;align-items:center;justify-content:space-between;background-color:transparent;font-family:'Lato',sans-serif;font-size:14px;padding:14px 15px;&:hover,&[item-highlighted='true']{background:#f2f8fd;}"]);
var Container =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "Dropdown__Container",
  componentId: "n49ci5-4"
})(["position:relative;border-radius:3px;background-color:", ";", "{border:1px solid ", ";border-radius:3px;&:hover,&:focus{border-color:", ";}&:disabled{border:1px solid ", ";}}&[aria-expanded='true']{", "{border-bottom-left-radius:0;border-bottom-right-radius:0;border-bottom:0;border-color:", ";}box-shadow:0 3px 8px 0 #ededed;", "{color:", ";transform:rotate(0deg);}}&[aria-invalid='true']{", "{border-color:", ";}", "{border-left-color:", ";border-right-color:", ";border-bottom-color:", ";}}"], function (props) {
  return props.theme.color.text.white;
}, Button, function (props) {
  return props.theme.color.grey.light;
}, function (props) {
  return props.theme.color.primary.lightBlue;
}, function (props) {
  return props.theme.color.grey.light;
}, Button, function (props) {
  return props.theme.color.primary.lightBlue;
}, Caret, function (props) {
  return props.theme.color.primary.lightBlue;
}, Button, function (props) {
  return props.theme.color.primary.red;
}, ItemList, function (props) {
  return props.theme.color.primary.red;
}, function (props) {
  return props.theme.color.primary.red;
}, function (props) {
  return props.theme.color.primary.red;
});
var StyledDropdown = createDropdown(Container, ItemList, Button, Item);

var Dropdown =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Dropdown, _React$Component);

  function Dropdown() {
    _classCallCheck(this, Dropdown);

    return _possibleConstructorReturn(this, _getPrototypeOf(Dropdown).apply(this, arguments));
  }

  _createClass(Dropdown, [{
    key: "render",
    value: function render() {
      var fallbackOption = {
        value: '',
        label: 'Vælg'
      };
      var value = typeof this.props.value === 'number' ? this.props.value + '' : this.props.value;
      var selectedOption = this.props.choices.find(function (option) {
        return option.value === value;
      }) || this.props.defaultValue;
      return React.createElement(StyledDropdown, {
        className: this.props.className,
        disabled: this.props.disabled,
        "aria-invalid": this.props['aria-invalid'],
        id: this.props.id,
        options: this.props.choices,
        defaultValue: selectedOption || fallbackOption,
        onChange: this.props.onChange
      });
    }
  }]);

  return Dropdown;
}(React.Component);

export { Dropdown as default };